<header>
  <div class="header-page justify-items-between align-items-center">
    <div class="row pt-4">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
        <div class="row">
          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6">
            <img class=""
              src="{{ RESOURCE_SERVER_URL }}/assets/images/Header/Menu_Copy.svg"
              alt=""
            />
          </div>

          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6">
            <img
              class="search iconsColors"
              src="{{ RESOURCE_SERVER_URL }}/assets/images/search.svg"
              alt="img search"
            />
          </div>

          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-6 searchInput">
            <custom-input-text placeholder="{{ 'Search' }}">
            </custom-input-text>
          </div>
        </div>
      </div>

      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-6 cell">
        <span class="dateContent">{{ "Claims Office Business Date" | translate}} {{":"}}</span>
        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 pl-0 mr-3 dateAlign">
          <custom-date-picker class="dateHeader"
          (valueChange)="dataInput($event)"  [errorMessage]="error"
          [model]="businessDate" [disabled]="disableBusinessDate"
          ></custom-date-picker>
        </div>
        <div class="dropdown profile-menu">
          <div
            class="dropdown-menu dropdown-menuRegion scrollable-menu dropdown-menu-left dropdown-menu-lg-right"
            aria-labelledby="dropdownMenuButton" id="showdropdownMenuButton">
            <div class="profile-info" (click)="navigatetohome()">
              <div class="details">
                <span class="name">{{getUserName()}}</span>
                <span class="pro-id">Profile ID - {{profilename()}}</span>
              </div>
              <div class="pro-icon">
                <img
                  src="{{
                    RESOURCE_SERVER_URL +
                      '/assets/images/Underwriting_new/Header/Profile_top.svg'
                  }}" alt=""/>
              </div>
            </div>
            <div class="sign-out" (click)="onSignOut()">
              <label>{{"label.common.signOut" | translate}}</label>
            </div>
          </div>
          <button
            class="btn buttonRegion"
            type="button">
            <img
              id="dropdownMenuButton"
              src="{{
                RESOURCE_SERVER_URL +
                  '/assets/images/Underwriting_new/Header/Profile_top.svg'
              }}"
              alt=""
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
